export const getToken = () => {
  let accessToken;
  if (localStorage.getItem("token") !== null) {
    let token = JSON.parse(localStorage.getItem("token"));
    accessToken = token?.accessToken;
  }
  return accessToken;
};
